import React from 'react'
import { AppBar,Avatar,Button,Toolbar,Typography } from '@material-ui/core';
import useStyles from './styles.js';
import memoriesLogo from '../../images/memories-Logo.png';
import memoriesText from '../../images/memories-Text.png';
import {Link} from 'react-router-dom';
import { useState,useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate ,useLocation} from 'react-router-dom';


const Navbar = () => {

    const classes = useStyles();
    const [user,setUser] = useState(JSON.parse(localStorage.getItem('profile')));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    //console.log(user);


    useEffect(()=>{
        setUser(JSON.parse(localStorage.getItem('profile')))

    },[location])

    const logout = () => {

        dispatch({type:"LOGOUT"})
        navigate("/auth");
        setUser(null);

    }

  return (
    <AppBar className={classes.appBar} position="static" color="inherit">
    <Link to="/" className={classes.brandContainer}>
    <img src={memoriesText} alt="icon" height="45px"/>
        <img className={classes.image} src={memoriesLogo} alt="icon" height="60" />
    </Link>
        <Toolbar className={classes.toolbar}>
            {
                user ? (
                    
                    <div className={classes.profile}>
                        <Avatar className={classes.purple} alt={user.result.name} src={user.result.imageUrl}>{user.result.name.charAt(0)}</Avatar>
                        <Typography className={classes.userName} variant="h6">{user.result.name}</Typography>
                        <Button variant="contained" className={classes.logout} color="secondary" onClick={logout}>Logout</Button>
                    </div>


                ) :(
                    <Button component={Link} to="/auth" variant="contained" color="primary">Sign In</Button>
                )



            }


        </Toolbar>
      </AppBar>
  )
}

export default Navbar